<template>
    <div class="journey-location">
        <span v-if="date" class="journey-location-time" v-tippy="getShortDate(date)">
            {{ dateLabel }}
        </span>
        <span class="journey-location-details">
            <span v-if="data.name">{{ data.name }}</span>
            <!-- <span v-if="data.location">{{ data.location }}</span>
            <span v-if="data.code">({{ data.code }})</span> -->
        </span>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { getTime, convertToDate, getShortDate } from '@shared/helpers/datetime/datetime';
    import { JourneyLocation, JourneyDateDisplay } from '../../Journey.interfaces';
    import {
        getLocaleDayShortMonth,
        getLocaleDayShortMonthTime,
    } from '@shared/helpers/datetime/datetime.formatters';

    export default defineComponent({
        name: 'Location',
        methods: { getShortDate },
        props: {
            data: {
                type: Object as PropType<JourneyLocation>,
                required: true,
            },
        },
        setup(props) {
            const date = computed((): Date | null =>
                props.data.date ? convertToDate(props.data.date) : null
            );

            const dateLabel = computed((): string | null => {
                if (!date.value) return null;

                switch (props.data.dateDisplay) {
                    case JourneyDateDisplay.Date:
                        return getLocaleDayShortMonth(date.value);
                    case JourneyDateDisplay.DateTime:
                        return getLocaleDayShortMonthTime(date.value);
                    default:
                        return getTime(date.value);
                }
            });

            return {
                date,
                dateLabel,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Location.scss';
</style>
